// import site_logo from '../Assets/Icon/Logo.png';
// import site_logo_dark from '../Assets/Icon/Logo.png';
// import depositINR_qrcode from '../Assets/Image/qrcode.png';
// import userPopUp from '../Assets/Image/user-banner-nexus.png';
// import nexusPdf from '../Assets/Image/nexus.pdf';
// import nexusPDF from '../Assets/Image/nexus.pdf';

// export const logo = site_logo;
// export const dark_logo = site_logo_dark;
export const title = 'Queen Nutrition';
export const websiteName = 'Queen Nutrition';
export const shortTitle = 'Queen Nutrition';
export const titleDescription = 'Queen Nutrition';
// export const Image_path = site_logo;
export const des_upi = "yespay123@payts.com";
// export const pdfFile = nexusPDF;

// export const qrcode = depositINR_qrcode;

// export const website = 'http://techidea.store/';
export const website = 'https://nexustradezz.in/';

// export const api_url = 'http://192.168.18.23:8001/api/v1/';
// export const api_url = 'https://api.nexustradezz.in/api/v1/';

// export const api_url = 'http://192.168.1.2:8001/api/v1/';
export const api_url = 'http://localhost:8000/api/v1/';
// export const api_url = 'http://192.168.1.2:8001/api/v1/';

export const key_secure_front = '@25ne||x877!!31';
export const currency = '$';





